import React, { useEffect, useState, useMemo } from 'react'
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import ReactTableComponent from "../../components/Table/ReactTableComponent";
import ReactTooltip from "react-tooltip";
import { useHistory } from "react-router-dom";
import { callAPI } from "../../_helper/index";
import { toast } from "react-toastify";
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Row,
    Col,
    Table,
} from "reactstrap";
import { Spinner } from 'reactstrap';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
function StoreMaster() {

    const COLUMNS = [
        {
            Header: "Action",
            Footer: "Action",
            accessor: (originalRow, rowIndex) => {
                return (
                    <>

                        <UncontrolledDropdown className="menu-dropdown">
                            <DropdownToggle>
                                <div className="dots"></div>
                                <div className="dots"> </div>
                                <div className="dots"></div>
                            </DropdownToggle>
                            <DropdownMenu>

                                <Row>
                                    <Col>
                                        <button
                                            data-tip
                                            data-for="EditStore"
                                            onClick={(e) => {
                                                history.push(`/admin/manage-store/${originalRow.Id}`);
                                            }}
                                            className="btn-edit"
                                        >

                                            <i className="now-ui-icons design-2_ruler-pencil" />
                                            Edit
                                        </button>
                                        <ReactTooltip id="EditStore" place="top" effect="solid">
                                            Edit Store
                                        </ReactTooltip>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <button
                                            data-tip
                                            data-for="DeleteStore"
                                            onClick={(e) => deleteStoreHandler(originalRow.Id)}
                                            className="btn-edit"
                                        >
                                            <i className="now-ui-icons ui-1_simple-remove" />
                                            Delete
                                        </button>
                                        <ReactTooltip id="DeleteStore" place="top" effect="solid">
                                            Delete Store
                                        </ReactTooltip>
                                    </Col>
                                </Row>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </>
                );
            },
            Cell: ({ value }) => {
                return value;
            },
        },
        {
            Header: "StoreName",
            Footer: "StoreName",
            accessor: "StoreName",
        }

    ];
    const columns = useMemo(() => COLUMNS, []);
    const [Store, setStore] = useState([])
    const history = useHistory();
    const [IsLoading, setIsLoading] = useState(true)

    useEffect(() => {
        getStore()
    }, [])

    const getStore = () => {
        var response = callAPI(`/api/stores`, "GET", null);
        response.then((res) => {
            setIsLoading(false)
            if (res.success) {
                setStore(res.data);
            } else {
                toast.error(res.message);
            }
        });
    }

    const deleteStoreHandler = (id) => {

        if (confirm("Are you sure you want to delete this store?")) {
            setIsLoading(true)

            var response = callAPI(`/api/stores/${id}`, "DELETE", null);
            response.then((res) => {
                setIsLoading(false)
                if (res.success) {
                    toast.success("Store Deleted Successfully!!!");
                    getStore();
                } else {
                    toast.error(res.message);
                }
            });
        }


    };


    return (
        <>
            <PanelHeader size="lg" />
            {
                IsLoading &&
                <div className="loader">
                    <Spinner color="white" />
                </div>
            }

            <div className="content">
                <Row>
                    <Col xs={12} md={12}>
                        <Card className="card-chart">
                            <CardHeader>
                                <Row>
                                    <Col md={6}>
                                        <CardTitle tag="h4">
                                            Store Master
                                        </CardTitle>
                                    </Col>
                                    <Col md={6} className="text-right">
                                        <button
                                            className="btn btn-info"
                                            onClick={(e) => {
                                                history.push("/admin/manage-store");
                                            }}
                                        >
                                            Add Store
                                        </button>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col></Col>
                                </Row>


                            </CardHeader>
                            <CardBody>
                                {Store.length ? (
                                     
                                    <ReactTableComponent data={Store} columns={columns} />
                                   
                                ) : null}

                            </CardBody>
                            <CardFooter>
                                <div className="stats"></div>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default StoreMaster
